import React, { useState } from 'react';
import { TYPO, R, S, SHADCN } from '../theme';

// Titre date cliquable pour l'onglet Today.
// Clic → révèle un petit chip discret avec progression année / mois (easter egg utile).
//
// Time-of-day : tard le soir (22h→6h), le titre prend une teinte légèrement
// bleutée — signal subtil "tu bosses dans la nuit". Aube (6h→9h) très léger
// crépuscule chaud. Reste neutre en journée.
function timeOfDayTint(h) {
  if (h >= 22 || h < 6)  return 'oklch(0.96 0.025 250)'; // nuit — bleu froid
  if (h < 9)             return 'oklch(0.96 0.028 65)';  // aube — chaud
  return null;
}

export default function TodayDateTitle({ title, now }) {
  const [revealed, setRevealed] = useState(false);

  // Date passée (now = null) : titre statique, ni chip ni teinte.
  if (!now) return <span style={{ ...TYPO.h1, color: SHADCN.fg, display: 'inline-block' }}>{title}</span>;

  const startOfYear = new Date(now.getFullYear(), 0, 1);
  const dayOfYear = Math.floor((now - startOfYear) / 86400000) + 1;
  const week = Math.ceil(((now - startOfYear) / 86400000 + startOfYear.getDay() + 1) / 7);
  const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  const monthPct = Math.round((now.getDate() / daysInMonth) * 100);
  const tint = timeOfDayTint(now.getHours());

  return (
    <>
      <button
        type="button"
        onClick={() => setRevealed(v => !v)}
        title={revealed ? 'Masquer' : 'Tu sais quoi ?'}
        style={{
          all: 'unset',
          cursor: 'pointer',
          ...TYPO.h1,
          color: tint || SHADCN.fg,
          display: 'inline-block',
          transition: 'color 1200ms cubic-bezier(0.22, 1, 0.36, 1)',
        }}
      >
        {title}
      </button>
      {revealed && (
        <div style={{ marginTop: 8, display: 'inline-flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
          <span style={{
            ...TYPO.caption,
            ...TYPO.num,
            color: SHADCN.mutedFg,
            padding: `2px ${S[2]}px`,
            border: `1px solid ${SHADCN.border}`,
            borderRadius: R.pill,
          }}>
            Jour {dayOfYear} · semaine {week} · {monthPct}% du mois
          </span>
        </div>
      )}
    </>
  );
}
